/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black top_tit" :to="{ name: 'manageCheckImplementationMenuList'} ">
                        <p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">チェック実施設定編集画面</p>
                </div>
            </div>
        </div>
        <CheckImplementationViewSetting/>
    </div>

</template>

<script>
    import CheckImplementationViewSetting from '@/app/components/CheckImplementationViewSetting.vue'
    export default {
        name: 'manageCheckImplementationViewSetting',
        components: {
            CheckImplementationViewSetting
        }
    }
</script>
